import React, { useState } from 'react'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import UpdateTimeTicketState from './UpdateTimeTicketState.form'

// queries
import { useMutation } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_APPROVAL, GET_JOB_DAY_WITH_NAME_DATE_AND_STATUS } from '../../../../../graphql/jobDay/jobDay.queries'
import { apolloClient } from '../../../../..'
import { UPDATE_APPROVAL_FOR_CREW_MEMBER_ASSIGNMENTS_MUTATION } from '../../../../../graphql/crewMemberAssignment/crewMemberAssignment.mutations'

// utils

import moment from 'moment'

const approvalStateReference = {
    "preliminary": "Approve Time Tickets",
    "final": "Approve Time Tickets"
}

const validationSchema = {
    date: {
        type: 'date',
        validation: {
            required: true,
            isDate: true
        }
    }
}

export default function UpdateTimeTicketStageFormController({ id, approvalStage, visible, closeForm }) {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [assignments, setAssignments] = useState(null)
    const [jobDay, setJobDay] = useState(null)
    const [nextApprovalState, setNextApprovalState] = useState(null)
    const [approveTimeTickets] = useMutation(UPDATE_APPROVAL_FOR_CREW_MEMBER_ASSIGNMENTS_MUTATION)
    const [errors, setErrors] = useState({})

    const handleSubmit = (formData) => {
        approveTimeTickets({ variables: {assignments: formData.assignments.map(assignment => ({
            id: parseInt(assignment.id, 10),  // ✅ Convert string to integer
            approvalStage
        }))}, refetchQueries: [GET_JOB_DAY_WITH_NAME_DATE_AND_STATUS]})
        .catch(e => console.error(e))
        .then(result => {
            if(result) {
                closeForm()
            }
        })
    }

    if(visible && isFetchingObject) {
        apolloClient.query({ query:GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_APPROVAL, variables: { id }}).catch(e => {})
        .then(result => {
            if(result) {
                setAssignments(result.data.jobDay.crewMemberAssignments)
                setJobDay(result.data.jobDay)
                setNextApprovalState("final")
                setIsFetchingObject(false)
            }
        })

        return null
    }

    else if(visible && !isFetchingObject && assignments) {
        const editVariants = [
            {
                name: 'Approve Time Tickets',
                component: <UpdateTimeTicketState />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText={'Approve Time Tickets'}
            onClose={() => {
                setErrors({})
                closeForm()
            }}  
            onSubmit={handleSubmit}
            title={`Approve Time Tickets - ${approvalStage.charAt(0).toUpperCase() + approvalStage.slice(1)}`}
            variants={editVariants}
            prefillData={{assignments, jobDay}}
            errors={errors}
        />)
    }

    return null
}

